export const ScenarioTypes = {
  CurrentInterestRate: "currentInterestRate",
  BestExistingInterestRate: "bestExistingInterestRate",
  BestNewInterestRate: "bestNewInterestRate",
};

export const ScenarioPaths: Record<ScenarioTypes, number> = {
  currentInterestRate: 0,
  bestExistingInterestRate: 1,
  bestNewInterestRate: 2,
};

export const InvalidScenarioAccountTypes = [
  "credit-card",
  "credit",
  "loan",
  "mortgage",
  "investment",
  "insurance",
  "foreign",
  "unknown",
  "stock",
  "other",
];

export type ScenarioTypes = (typeof ScenarioTypes)[keyof typeof ScenarioTypes];
